exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-statusContainer-25DSo{display:flex;align-items:baseline}.style-cssmodule-actions-Og8p- a{display:grid;place-content:center}.style-cssmodule-actions-Og8p- svg{stroke-width:1.5px;color:var(--color-night-gray6);fill:var(--color-night-gray6);stroke:var(--color-night-gray6)}.style-cssmodule-actions-Og8p- button{all:unset;box-sizing:border-box;cursor:pointer;display:grid;place-items:center;padding:5px}.style-cssmodule-tooltipWithCopy-2p2oo{display:flex;flex-direction:column;align-items:center}.style-cssmodule-tooltipWithCopy-2p2oo:last-child{font-size:1px!important}.style-cssmodule-usernameContainer-32O7O{max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.style-cssmodule-carparkContainer-3EfyQ{max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.style-cssmodule-emailContainer-25xc2{max-width:175px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"statusContainer": "style-cssmodule-statusContainer-25DSo",
	"actions": "style-cssmodule-actions-Og8p-",
	"tooltipWithCopy": "style-cssmodule-tooltipWithCopy-2p2oo",
	"usernameContainer": "style-cssmodule-usernameContainer-32O7O",
	"carparkContainer": "style-cssmodule-carparkContainer-3EfyQ",
	"emailContainer": "style-cssmodule-emailContainer-25xc2"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/ParkingRow/style.cssmodule.css
// module id = 2557
// module chunks = 121